<form [formGroup]="form">
  <file-upload formControlName="files" [fileslimit]="fileLimit" [accept]="fileAccept"></file-upload>
</form>